/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class LearningPlanGoalProgressApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'LearningPlanGoalProgresses');
  }

  getSchoolYearsForLearningPlanGoalProgress(bookId: number): Observable<number[]> {
    const path = `get-school-years`;
    const params = { bookId };
    const httpParams = this._getHttpParams(params);
    return this.get<number[]>(path, httpParams);
  }
}
